import { useT } from "../i18n";
import type { Lang as LangCode } from "../i18n";

const LANG_OPTS: { code: LangCode; label: string }[] = [
  { code: "kk", label: "ҚА" },
  { code: "ru", label: "РУ" },
  { code: "en", label: "EN" },
];

// Компактный переключатель языка для шапок стафф-панелей.
export default function LangPills() {
  const { lang, setLang } = useT();
  return (
    <div className="flex items-center gap-0.5 rounded-full bg-white/[0.06] ring-1 ring-white/15 p-0.5">
      {LANG_OPTS.map((opt) => (
        <button
          key={opt.code}
          type="button"
          onClick={() => setLang(opt.code)}
          className={`h-7 px-2.5 rounded-full text-[11px] font-bold transition-colors ${
            lang === opt.code ? "bg-violet-grad text-white" : "text-white/75 active:bg-white/10"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
